import React from "react";
import { useTranslation } from "react-i18next";

function PrivacyPolicyContent() {
  const { t } = useTranslation();

  return (
    <div style={{ padding: "40px 20px", margin: "0 auto" }}>

      <h3>{t("privacy.title")}</h3>

      {/*

      <p>{t("privacy.intro_1")}</p>

      
 */}




      <p>{t("privacy.intro_2")}</p>


      {/*

      <h4>{t("privacy.free_premium_title")}</h4>
      <p>{t("privacy.free_premium_desc")}</p>


      
      <ul style={{ textAlign: "left", display: "inline-block" }}>
        <li>{t("privacy.free_item")}</li>
        <li>{t("privacy.premium_item")}</li>
        <li>{t("privacy.subscription_item")}</li>
      </ul>

      <p>{t("privacy.subscription_time")}</p>

      
      */}


      <h4>{t("privacy.info_title")}</h4>
      <p>{t("privacy.info_desc")}</p>

      {/*


      <h4>{t("privacy.payment_title")}</h4>
      <p>{t("privacy.payment_desc")}</p>


*/}
      <h4>{t("privacy.log_title")}</h4>
      <p>{t("privacy.log_desc")}</p>

      <h4>{t("privacy.cookies_title")}</h4>
      <p>{t("privacy.cookies_desc")}</p>

      <h4>{t("privacy.security_title")}</h4>
      <p>{t("privacy.security_desc")}</p>

      <h4>{t("privacy.children_title")}</h4>
      <p>{t("privacy.children_desc")}</p>

      <h4>{t("privacy.changes_title")}</h4>
      <p>{t("privacy.changes_desc")}</p>

      <p>{t("privacy.effective_date")}</p>

      <h4>{t("privacy.contact_title")}</h4>
      <p>{t("privacy.contact_desc")}</p>

    </div>
  );
}

export default PrivacyPolicyContent;